
const headers = [
    {
      label: 'รหัสกลุ่ม / วันที่สร้างกลุ่ม',
      field: 'groupCreateDate'
    },
    {
      label: 'ผู้ประกอบการ',
      field: 'groupCompanyName',
    },
    {
      label: 'ชื่อกลุ่ม',
      field: 'groupIssue',
    },
    {
      label: 'สร้างกลุ่มโดย',
      field: 'groupCreateBy',
    },
    {
      label: 'วันที่ดำเนินการล่าสุด / สถานะล่าสุด',
      field: 'groupStatus',
    },
    {
      label: 'หน่วยงานรับผิดชอบ / ผู้รับผิดชอบ',
      field: 'groupOperatorName',
    },
  ]

  export default headers